exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".choicepinyin .middlediv .el-radio{height:32px;line-height:32px}", ""]);

// exports
